import { useDeviceType } from '@cian/ui-kit';
import { useState, useTransition, useLayoutEffect } from 'react';

interface IParams {
  isRevisited: boolean;
}

export function useDeferredRender({ isRevisited }: IParams): boolean {
  const [isPending, startTransition] = useTransition();
  const deviceType = useDeviceType();

  /*
   * Огромное кол-во отзывов блочит рендер и роняет INP при переключении на таб на мобилке.
   * Постраничная навигация не реализована из-за требований SEO.
   */
  const shouldDefer = isRevisited && deviceType === 'phone';
  const [shouldRender, setShouldRender] = useState(!shouldDefer);

  useLayoutEffect(() => {
    if (shouldDefer) {
      startTransition(() => {
        setShouldRender(true);
      });
    }
  }, [shouldDefer]);

  return shouldRender && !isPending;
}
